// extracted by mini-css-extract-plugin
export default {"wrapper":"hBjyGI","title":"fTlr1Y"};